<template>
  <div>
    <b-container>
      <b-row>
        <b-col>
          <h1>Rim Normal</h1>
          <iframe
            src="https://docs.google.com/presentation/d/e/2PACX-1vSNyVVGD087bSmtyrlSBSJAqV1KiFYHFQFhYzThZhcPpip3QHxxAqjfQYaT5HxGIw/embed?start=false&loop=false&delayms=3000"
            frameborder="0"
            width="100%"
            height="600"
            allowfullscreen="true"
            mozallowfullscreen="true"
            webkitallowfullscreen="true"
          ></iframe>
        </b-col>
      </b-row>
    </b-container>

    <b-container>
      <b-row align-h="center" class="text-center">
        <b-col sm="12" md="3">
          <router-link to="/rim-normal" class="pagination-link">ANTERIOR</router-link>
          <router-link to="/modulos" class="pagination-link">FINALIZAR</router-link>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Intro"
};
</script>

<style scoped>
.list-item {
  list-style-type: square;
  list-style-position: inside;
  text-align: justify;
}
.list-img {
  list-style-type: decimal-leading-zero !important;
  list-style-position: outside !important;
}
.pagination {
  margin: 0;
}
.pagination-link {
  margin-right: 15px;
}
</style>